import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import MockService from "@/core/mock/mock.service";
import { loggingOptions } from "@/core/config/logging";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";
// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
import ClipboardJS from "clipboard";

// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import InstantSearch from "vue-instantsearch";
import AsyncComputed from "vue-async-computed";
import VueLogger from "vuejs-logger";
import NProgress from "vue-nprogress";
import { handleDebugCookie } from "./core/utils/debugCookie";
import { Auth0Plugin, getInstance } from "./auth";

Vue.config.productionTip = false;

window.PerfectScrollbar = PerfectScrollbar;

window.ClipboardJS = ClipboardJS;

// Remove this to disable mock API
MockService.init();

export const authGuard = (to, from, next) => {
  const authService = getInstance();

  const fn = () => {
    // If the user is authenticated, continue with the route
    if (authService.isAuthenticated()) {
      return next();
    }

    // Otherwise, log in
    authService.loginWithRedirect({ appState: { targetUrl: to.fullPath } });
  };

  // If loading has already finished, check our auth state using `fn()`
  if (!authService.loading) {
    console.log("auth service not loading");
    return fn();
  }

  // Watch for the loading property to change before we check isAuthenticated
  authService.$watch("loading", loading => {
    if (loading === false) {
      console.log("not loading anymore");
      return fn();
    }
  });
};

const nProgressOptions = {
  latencyThreshold: 200, // Number of ms before progressbar starts showing, default: 100,
  router: true, // Show progressbar when navigating routes, default: true
  http: true // Show progressbar when doing Vue.http, default: true
};

const nprogress = new NProgress(nProgressOptions);

router.beforeEach((to, from, next) => {
  // reset config to initial state
  store.dispatch(RESET_LAYOUT_CONFIG).then(next);
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN || "vonq.eu.auth0.com",
  clientId:
    process.env.VUE_APP_AUTH0_CLIENT_ID || "6yX4D7iWezYbHpxy2PP0rtYyRqnbMFJc",
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    );
  },
  prompt: "select_account"
});

Vue.config.productionTip = false;
export const app = new Vue({
  router,
  store,
  i18n,
  vuetify,
  nprogress,
  render: h => h(App)
}).$mount("#app");

Vue.use(InstantSearch);
Vue.use(AsyncComputed);
Vue.use(VueLogger, loggingOptions);

Vue.use(NProgress, nProgressOptions);

const debugCookies = new URLSearchParams(window.location.search).getAll(
  "debugCookie"
);
debugCookies.forEach(debugCookie => handleDebugCookie(debugCookie));
